import { yAxisSplitLine } from './echartOptionCommon'

export function NumberConferenceTerminalsParticipantsEchartOp ({ v, data }) {
  let option = {
    tooltip: {
      trigger: 'axis'
    },
    color: ['rgba(255, 95, 165, 1)', 'rgba(0, 114, 255, 1)'],
    grid: {
      left: '5%',
      top: '15%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: [...data.date],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: yAxisSplitLine
    },
    legend: {
      data: [...data.name],
      icon: 'circle',
      textStyle: {
        color: 'rgba(255, 255, 255,1)'
      },
      itemHeight: v.fontSizeRem(0.45),
      itemWidth: v.fontSizeRem(0.45),
      right: 0
    },
    series: [
      // {
      //   name: '会议成员',
      //   data: [152, 277, 402],
      //   type: 'line',
      //   smooth: true,
      //   symbol: 'none'
      // },
      // {
      //   name: '会议终端',
      //   data: [54, 92, 114],
      //   type: 'line',
      //   smooth: true,
      //   symbol: 'none'
      // }
      ...data.data
    ]
  }
  return option
}
export function ConferenceLargeScreenDocumentUsageEchartOp ({ v, data }) {
  let option = {
    tooltip: {
      trigger: 'axis'
    },
    grid: {
      left: '5%',
      top: '15%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: [...data.date],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: yAxisSplitLine
    },
    legend: {
      data: [...data.name],
      icon: 'circle',
      textStyle: {
        color: 'rgba(255, 255, 255,1)'
      },
      itemHeight: v.fontSizeRem(0.45),
      itemWidth: v.fontSizeRem(0.45),
      right: 0

    },
    series: [
      // {
      //   data: [820, 932, 901, 934, 1290, 1330, 1320],
      //   type: 'line',
      //   smooth: true,
      //   symbol: 'none',
      //   itemStyle: {
      //     color: 'rgba(2, 94, 226, 1)'
      //   }
      // },
      {
        ...data.data[0],
        type: 'bar',
        smooth: true,
        symbol: 'none',
        barWidth: v.fontSizeRem(0.28),
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: 'rgba(42, 187, 255, 1)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(2, 94, 226, 1)' // 100% 处的颜色
            }]
          }
        }
      },
      {
        ...data.data[1],
        type: 'bar',
        smooth: true,
        symbol: 'none',
        barWidth: v.fontSizeRem(0.28),
        barGap: v.fontSizeRem(0.03),
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: 'rgba(255, 138, 190, 1)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(243, 37, 122, 1)' // 100% 处的颜色
            }]
          }
        }
      }
    ]
  }
  return option
}
export function NumberDurationMeetingsEchartOp ({ v, data }) {
  let option = {
    // 'rgba(2, 94, 226, 1)',、
    color: [ {
      type: 'linear',
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0, color: 'rgba(42, 187, 255, 1)' // 0% 处的颜色
      }, {
        offset: 1, color: 'rgba(2, 94, 226, 1)' // 100% 处的颜色
      }]
    }, {
      type: 'linear',
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [{
        offset: 0, color: 'rgba(255, 138, 190, 1)' // 0% 处的颜色
      }, {
        offset: 1, color: 'rgba(243, 37, 122, 1)' // 100% 处的颜色
      }]
    } ],
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: [...data.name],
      icon: 'circle',
      textStyle: {
        color: 'rgba(255, 255, 255,1)'
      },
      itemHeight: v.fontSizeRem(0.45),
      itemWidth: v.fontSizeRem(0.45),
      right: 0

    },
    grid: {
      left: '5%',
      top: '15%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: [...data.date],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: [
      {
        name: '次',
        type: 'value',
        axisLabel: {
          color: 'rgba(255, 255, 255, 0.8)'
          // fontSize: v.fontSizeRem(0.75)
        },
        splitLine: yAxisSplitLine,
        splitNumber: 5,
        nameTextStyle: {
          color: 'rgba(255, 255, 255, 1)'
        }
      },
      {
        name: '小时',
        type: 'value',
        axisLabel: {
          color: 'rgba(255, 255, 255, 0.8)'
          // formatter: function (d, c, a) {
          //   return v.numberSplitWithComma(d / 3600)
          // }
          // fontSize: v.fontSizeRem(0.75)
        },
        splitLine: yAxisSplitLine,
        alignTicks: 'value',
        splitNumber: 5,
        nameTextStyle: {
          color: 'rgba(255, 255, 255, 1)'
        }
      }
    ],
    series: [
      // {
      //   data: [820, 932, 901, 934, 1290, 1330, 1320],
      //   type: 'line',
      //   smooth: true,
      //   symbol: 'none'
      // },
      {
        // name: '会议次数',
        // data: [
        //   104, 192, 229
        // ],
        ...data.data[0],
        type: 'bar',
        smooth: true,
        symbol: 'none',
        barWidth: v.fontSizeRem(0.28),
        barGap: v.fontSizeRem(0.03)
      },
      {
        // name: '会议时长',
        // data: [
        //   223580,
        //   296549,
        //   642624],
        ...data.data[1],
        type: 'bar',
        smooth: true,
        symbol: 'none',
        barWidth: v.fontSizeRem(0.28),
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: 'rgba(255, 138, 190, 1)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(243, 37, 122, 1)' // 100% 处的颜色
            }]
          }
        },
        yAxisIndex: 1
      }
    ]
  }
  return option
}

export function ProportionTerminalDistributionEchartOp ({ v }) {
  let option = {
    color: [
      {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(243, 37, 122, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(255, 116, 178, 1)' // 100% 处的颜色
        }]
      },
      {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(250, 139, 39, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(255, 230, 101, 1)' // 100% 处的颜色
        }]
      },
      {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(0, 245, 194, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(0, 182, 211, 1)' // 100% 处的颜色
        }]
      },
      {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(4, 94, 226, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(0, 176, 255, 1)' // 100% 处的颜色
        }]
      }
    ],
    grid: {
      left: '5%',
      top: '10%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    legend: {
      icon: 'circle',
      right: 0,
      data: ['安卓', 'iOS', 'Win', 'Mac'],
      textStyle: {
        color: 'rgba(255, 255, 255, 0.8)'
      }
    },
    series: [
      {
        name: '访问来源',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '30',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          { value: 335, name: 'iOS' },
          { value: 310, name: 'Win' },
          { value: 234, name: 'Mac' },
          { value: 135, name: '安卓' }
        ]
      }
    ]
  }
  return option
}

export function ProportionUrbanDistributionEchartOp ({ v }) {
  // new echarts.graphic.LinearGradient(1, 0, 0, 1, [{ offset: 0, color: '#01C7E5' }, { offset: 1, color: '#042CF3' }])
  let option = {
    color: [],
    legend: {
      show: false,
      icon: 'circle',
      data: ['遥控器', '新增激活', '手机APP', '阵列MAC'],
      textStyle: {
        color: 'rgba(255, 255, 255, 0.8)'
      }
    },
    grid: {
      left: '0%',
      top: '0%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: [{
      type: 'value',
      show: false,
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      }
    }],
    yAxis: [{
      type: 'category',
      data: ['普通', '广东', '东北', '湖南', '湖北', '西安', '山东'],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: yAxisSplitLine
    }],

    series: [{
      type: 'bar',
      color: {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: '#01C7E5' // 0% 处的颜色
        }, {
          offset: 1, color: '#042CF3' // 100% 处的颜色
        }]
      },
      data: [1, 2, 3, 4, 5, 6, 7],
      barWidth: v.fontSizeRem(1.25),
      showBackground: true,
      backgroundStyle: {
        color: 'rgba(255, 255, 255, 0.1)'
      },
      label: {
        position: 'insideRight',
        show: false,
        textBorderColor: '#333',
        textBorderWidth: 2,
        color: 'rgba(255,255,255,1)'
      }
    }]
  }

  return option
}
